import { Injectable } from '@angular/core';
import { AngularFireDatabase } from "@angular/fire/database";

//import { auth } from 'firebase/app';
import { Observable } from 'rxjs';		//, ReplaySubject 
import { map } from 'rxjs/operators';		//, tap, catchError, first
import { CfgVarias, CfgTemaOpciones, CfgSecure, TextosPorProducto } from '../interfaces/varias-interfaces';
import { DatosSRI, LineaPdf, LineaXml, DatosEscalasPDF } from '../interfaces/factura-interfaces';
import { LogService } from "../servicios/log-servicios";
import { DataEmpresaService } from '../servicios/data-empresa-servicios';

@Injectable({
  providedIn: 'root'
})
export class FireConfigService {
  constructor(
    private db: AngularFireDatabase,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) { }


  xml1: LineaXml[] = [];
  pdf1: LineaPdf[] = [];


  getFireCfgVarias$(): Observable<CfgVarias> {
    return this.db.object<CfgVarias>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/varias')
      .valueChanges()
      .pipe(
        map(fcv => {
          if (fcv.logNivel == undefined) {
            this.logService.consoleLog('2', 'CS FC fcv vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC fcv service get, log: ' + fcv.logNivel);
          }
          return fcv;
        })
      );
  }

  getFireTextosPorProducto$(prod: string, subprod: string): Observable<TextosPorProducto> {
    const ps: string = prod + subprod;
    let prodsub = '';
    switch (ps) {
      case 'EasyMedMédico':
        prodsub = 'easymedmedico';
        break;
      case 'EasyMedBelleza':
        prodsub = 'easymedbelleza';
        break;
      case 'EfisysFacturación':
        prodsub = 'efisysfacturacion';
        break;
      default:
        prodsub = 'easymedmedico';
        break;
    }
    return this.db.object<TextosPorProducto>(`easymed/${this.dataEmpresaService.empAut.prefijoBase}/config/textosporproducto/${prodsub}`)
      .valueChanges()
      .pipe(
        map(ftpp => {
          if (ftpp.denomPacFirstUp == undefined) {
            this.logService.consoleLog('2', 'CS FC ftpp vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC ftpp service get, log: ' + ftpp.denomPacFirstUp);
          }
          return ftpp;
        })
      );
  }

  //update puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  updateFireCfgVarias$(objCfgVarias: CfgVarias): Promise<void> {
    this.logService.consoleLog('2', 'CS FC update cfgv');
    this.logService.consoleLog('2', 'CS FC ' + objCfgVarias.logNivel);
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/')
      .update('varias', objCfgVarias);
  }

  getFireDatosSRI$(): Observable<DatosSRI> {
    return this.db.object<DatosSRI>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/datosSRI')
      .valueChanges()
      .pipe(
        map(fds => {
          if (fds.razonsocial == undefined) {
            this.logService.consoleLog('2', 'CS FC fds vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC fds service get, long: ' + fds + ', ambiente: ' + fds.ambienteactual);
          }
          return fds;
        })
      );
  }

  //update puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  updateFireDatosSRI$(objDatosSRI: DatosSRI): Promise<void> {
    this.logService.consoleLog('2', 'CS FC update dsri');
    this.logService.consoleLog('2', 'CS FC ' + objDatosSRI.ruc);
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/')
      .update('datosSRI', objDatosSRI);
  }

  getFireCfgSecure$(): Observable<CfgSecure> {
    return this.db.object<CfgSecure>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/secure')
      .valueChanges()
      .pipe(
        map(fcs => {
          if (fcs.keeptxtpdf == undefined) {
            this.logService.consoleLog('2', 'CS FC fcs vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC fcs service get, long: ' + fcs + ', mail: ' + fcs.mail);
          }
          return fcs;
        })
      );
  }

  //update puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  updateFireCfgSecure$(objCfgSecure: CfgSecure): Promise<void> {
    this.logService.consoleLog('2', 'CS FC update dsri');
    this.logService.consoleLog('2', 'CS FC ' + objCfgSecure.mail);
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase)
      .update('secure', objCfgSecure);
  }

  updateFireCfgSecureUnaSola$(cfg: string, valor: string): Promise<void> {
    this.logService.consoleLog('2', 'CS FC update dsec una sola, cfg: ' + cfg);
    const obj: object = {};
    obj[cfg] = valor; //esto crea algo como {miCfg: miValor}
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase)
      .update('secure', obj);
  }

  getFireTradChar$(): Observable<object> {
    return this.db.object<object>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/tradchar')
      .valueChanges()
      .pipe(
        map(trad => {
          this.logService.consoleLog('2', 'TradChar leído Á = ' + trad['Á']);
          return trad;
        })
      );
  }

  getFireEscalasPdf$(): Observable<DatosEscalasPDF> {
    return this.db.object<DatosEscalasPDF>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/docelec/escalas')
      .valueChanges()
      .pipe(
        map(fep => {
          if (fep.escalapdf == undefined) {
            this.logService.consoleLog('2', 'CS FC fep vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC fep service get, long: ' + fep + ', escpdf: ' + fep.escalapdf);
          }
          return fep;
        })
      );
  }

  getFireFacXML$(): Observable<LineaXml[]> {
    return this.db.list<LineaXml>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/docelec/factura222', ref =>
      ref.orderByChild('sec')
    )
      .valueChanges()
      .pipe(
        map(ffxs => {
          if (ffxs.length === 0) {
            this.logService.consoleLog('2', 'CS fireFacXml ffxs vacío');
          } else {
            this.logService.consoleLog('2', 'CS fireFacXml ffxs service get, long: ' + ffxs.length + ', 0: ' + ffxs[0].etiq);
            this.xml1 = ffxs;
          }
          return this.xml1;
        })
      );
  }

  getFireFacPDF$(): Observable<LineaPdf[]> {
    return this.db.list<LineaPdf>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/docelec/facturapdf', ref =>
      ref.orderByChild('sec')
    )
      .valueChanges()
      .pipe(
        map(ffps => {
          if (ffps.length === 0) {
            this.logService.consoleLog('2', 'CS fireFacPdf ffps vacío');
          } else {
            this.logService.consoleLog('2', 'CS fireFacPdf ffps service get, long: ' + ffps.length + ', 0: ' + ffps[0].efisys);
            this.pdf1 = ffps;
          }
          return this.pdf1;
        })
      );
  }

  // ----------------- OJO  Hacer un solo get de todas las configuraciones de opciones ------------------------------//
  getFireCfgOpcCombos$(): Observable<CfgTemaOpciones[]> {
    return this.db.list<CfgTemaOpciones>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/config/opcionescombos/')
      .valueChanges()
      .pipe(
        map(opccombos => {
          if (opccombos.length === 0) {
            this.logService.consoleLog('2', 'CS FC opccombos vacío');
          } else {
            this.logService.consoleLog('2', 'CS FC opccombos service get, long: ' + opccombos.length);
          }
          return opccombos;
        })
      );
  }

}
